
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/br/[tickerSymbol]/quotes",
      function () {
        return require("private-next-pages/br/[tickerSymbol]/quotes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/br/[tickerSymbol]/quotes"])
      });
    }
  